'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaults = {
  maxYears: 100,
  minYears: null,
  minDays: 14,
  maxEffDays: 364,
  maxExpDays: 364,
  seniorMaxCoverageDays: 34,
  maxTripBookedYears: 50
};

var DateFunction = function (_React$Component) {
  _inherits(DateFunction, _React$Component);

  function DateFunction() {
    _classCallCheck(this, DateFunction);

    return _possibleConstructorReturn(this, (DateFunction.__proto__ || Object.getPrototypeOf(DateFunction)).apply(this, arguments));
  }

  _createClass(DateFunction, null, [{
    key: 'setMinDobDate',
    value: function setMinDobDate(age) {
      return (0, _moment2.default)().subtract({ years: age }).add({ days: 1 });
    }
  }, {
    key: 'getMinExpiryDate',
    value: function getMinExpiryDate(formValues) {
      return (0, _moment2.default)(formValues.application.effective_date || (0, _moment2.default)().format('YYYY-MM-DD')).add(1, 'days');
    }
  }, {
    key: 'getApplicantDobs',
    value: function getApplicantDobs(formValues) {
      var allApplicants = formValues.applicant;

      if (!Array.isArray(allApplicants)) {
        allApplicants = [formValues.applicant].concat(_toConsumableArray(formValues.applicants));
      }

      return allApplicants.map(function (applicant) {
        return (0, _moment2.default)(applicant.dob);
      });
    }
  }, {
    key: 'getMaxEffectiveDate',
    value: function getMaxEffectiveDate(formValues, age, maxDays) {
      var minDob = _moment2.default.min(this.getApplicantDobs(formValues));
      return _moment2.default.min([(0, _moment2.default)().add({ days: maxDays }), minDob.add({ years: age }).subtract({ days: 1 })]);
    }
  }, {
    key: 'getMaxExpiryDate',
    value: function getMaxExpiryDate(formValues, maxAge, maxDays, seniorMaxCoverageDays) {
      if (formValues.application.effective_date) {
        var minDob = _moment2.default.min(this.getApplicantDobs(formValues));

        if (_moment2.default.duration((0, _moment2.default)().diff(minDob)).asYears() >= maxAge) {
          return (0, _moment2.default)(formValues.application.effective_date).add(seniorMaxCoverageDays, 'days');
        }
        return (0, _moment2.default)(formValues.application.effective_date).add(maxDays, 'days');
      }

      return (0, _moment2.default)().add(maxDays, 'days');
    }
  }, {
    key: 'getRenewalDateRestrictions',
    value: function getRenewalDateRestrictions(dateType, existingExpiryDate, restrictedDays, dateRestrictions) {
      switch (dateType) {
        case 'effective':
          return {
            min: (0, _moment2.default)(dateRestrictions.application.effective_date).isAfter(existingExpiryDate) ? (0, _moment2.default)(dateRestrictions.application.effective_date) : (0, _moment2.default)(existingExpiryDate).add(1, 'days'),
            max: (0, _moment2.default)(existingExpiryDate).add(restrictedDays - 1, 'days')
          };
        case 'expiry':
          return {
            min: (0, _moment2.default)(dateRestrictions.application.expiry_date).isAfter(existingExpiryDate) ? (0, _moment2.default)(dateRestrictions.application.expiry_date) : (0, _moment2.default)(existingExpiryDate).add(2, 'days'),
            max: (0, _moment2.default)(existingExpiryDate).add(restrictedDays, 'days')
          };
        default:
          return null;
      }
    }
  }, {
    key: 'getDateLimits',
    value: function getDateLimits(formValues, dateLimits) {
      var maxYears = dateLimits.maxYears || defaults.maxYears;
      var maxEffDays = dateLimits.maxEffDays || defaults.maxEffDays;
      var maxExpDays = dateLimits.maxExpDays || defaults.maxExpDays;
      var seniorMaxCoverageDays = dateLimits.seniorMaxCoverageDays || defaults.seniorMaxCoverageDays;
      var seniorYears = dateLimits.seniorYears || maxYears;

      // update expiry date if we are in a leap year
      var leapYearDay = this.getLeapYearDay(formValues.application.effective_date, maxExpDays);
      var defaultLeapYearDay = this.getLeapYearDay(formValues.application.effective_date, defaults.maxExpDays);

      maxExpDays += leapYearDay;

      return {
        applicant: {
          dob: {
            min: this.setMinDobDate(maxYears),
            max: (0, _moment2.default)().subtract(defaults.minDays, 'days')
          }
        },
        applicants: {
          dob: {
            min: this.setMinDobDate(maxYears),
            max: (0, _moment2.default)().subtract(defaults.minDays, 'days')
          }
        },
        application: {
          tripbooked_date: {
            min: (0, _moment2.default)().subtract(defaults.maxTripBookedYears, 'years'),
            max: (0, _moment2.default)()
          },
          effective_date: {
            min: (0, _moment2.default)().subtract(dateLimits.backdateEffDays, 'days'),
            max: this.getMaxEffectiveDate(formValues, maxYears, maxEffDays)
          },
          expiry_date: {
            min: this.getMinExpiryDate(formValues),
            max: this.getMaxExpiryDate(formValues, seniorYears || maxYears, maxExpDays, seniorMaxCoverageDays)

          },
          default_expiry_date: formValues.application.effective_date ? (0, _moment2.default)(formValues.application.effective_date).add(maxExpDays, 'days') : null,
          multi_trip_expiry_date: formValues.application.effective_date ? (0, _moment2.default)(formValues.application.effective_date).add(defaults.maxExpDays + defaultLeapYearDay, 'days') : null
        }
      };
    }
  }, {
    key: 'getLeapYearDay',
    value: function getLeapYearDay(effective_date, maxExpDays) {
      if (effective_date && maxExpDays && maxExpDays === 364) {
        var effDate = (0, _moment2.default)(effective_date);
        var maxExpiry = (0, _moment2.default)(effective_date).add(maxExpDays + 1, 'days');
        var keyDate = (0, _moment2.default)().set({ month: 1, date: '28' });

        if (effDate.isLeapYear()) {
          keyDate.set({ date: '29', year: effDate.year() });
          if (effDate.isBefore(keyDate)) {
            return 1;
          }
        } else if (maxExpiry.isLeapYear()) {
          keyDate.set('year', maxExpiry.year());
          if (maxExpiry.isAfter(keyDate)) {
            return 1;
          }
        }
      }
      return 0;
    }
  }]);

  return DateFunction;
}(_react2.default.Component);

exports.default = DateFunction;


//////////////////
// WEBPACK FOOTER
// ./src/v2/helpers/dateFunctions.js
// module id = 57
// module chunks = 0